import Vuex from 'vuex';
import Vue from 'vue'
import Router from "vue-router"
import createPersistedState from 'vuex-persistedstate'
//加密
import SecureLS from "secure-ls"
//vuex,不能用this.$http,需要按需引入
import { getuserinfo,getMenu } from '../api';
Vue.use(Vuex)
var ls = new SecureLS({
  encodingType: "aes",    //加密类型
  isCompression: false,   
  encryptionSecret: "encryption",   //PBKDF2值
});
export default new Vuex.Store({
	plugins:[
		createPersistedState(
		{
		      key: "encryptionStore",
		      storage: {
		        getItem: (key) => ls.get(key),
		        setItem: (key, value) => ls.set(key, value),
		        removeItem: (key) => ls.remove(key),
		      },
		    }
	)//注入持久化插件
	],
	state:{
		userInfo:{},//保存用户信息
		menusList:[],//菜单
		menusChildren:[],//子菜单
		languageSave:'zh-CN',//中英文切换
	},
	mutations:{
		updateUserInfo(state,getuseInfo){
			state.userInfo = getuseInfo
		},
		updateMenu(state,getMenu){
			state.menusList = getMenu.dataMenuList
			state.menusChildren = getMenu.data
		},
		updateLanguage(state,info){
			state.languageSave = info
		},

	},
	 actions:{//请求接口
		// //请求->用户信息
	 async getUserInfoActions(store){
		 const { data: res } = await getuserinfo()
		if(res.status === 0){
			store.commit('updateUserInfo',res.data)
		}
		},
		async getMenus(store){
      return new Promise(async (resolve)=>{
        const { data: res } = await getMenu()
        if(res.status === 0){
			//数据扁平化
        	store.commit('updateMenu',res)
        }
        resolve()
        })

			}
	},
	getters:{
		username:(state) =>{
			return state.userInfo.username
		},
		nickname:(state) =>{
			return state.userInfo.nickname
		},
		phone:(state)=>{
			return state.userInfo.phone
		},
		user_pic:(state) =>{
			return state.userInfo.user_pic
		},
		statesw:(state) =>{
			return state.userInfo.statesw
		},
		id:(state)=>{
			return state.userInfo.id
		},
		rid:(state)=>{
			return state.userInfo.rid
		},
		//客服
		kf_id:(state)=>{
			return state.userInfo.kf_id
		},
		kf_username:(state)=>{
			return state.userInfo.kf_username
		},
		kf_phone:(state)=>{
			return state.userInfo.kf_phone
		},
		kf_email:(state)=>{
			return state.userInfo.kf_email
		},
		kf_landline:(state)=>{
			return state.userInfo.kf_landline
		},
		kf_qq:(state)=>{
			return state.userInfo.kf_qq
		},
		kf_wx_code:(state)=>{
			return state.userInfo.kf_wx_code
		},
		//销售
		xs_id:(state)=>{
			return state.userInfo.xs_id
		},
		xs_username:(state)=>{
			return state.userInfo.xs_username
		},
		xs_phone:(state)=>{
			return state.userInfo.xs_phone
		},
		xs_email:(state)=>{
			return state.userInfo.xs_email
		},
		xs_landline:(state)=>{
			return state.userInfo.xs_landline
		},
		xs_qq:(state)=>{
			return state.userInfo.xs_qq
		},
		xs_wx_code:(state)=>{
			return state.userInfo.xs_wx_code
		},
		menusList:(state)=>{
			return state.menusList
		},
		menusChildren:(state)=>{
			return state.menusChildren
		},
		languageSave:(state)=>{
			return state.languageSave
		},
		//等级
		customer_rating:(state)=>{
			return state.userInfo.customer_rating
		},
		//海运整箱历史查询
		historyquery_fcl:(state)=>{
			return state.userInfo.historyquery_fcl == null || state.userInfo.historyquery_fcl == '' ?  []:state.userInfo.historyquery_fcl.split("|")
		},
		query_pod_fcl:(state)=>{
			return state.userInfo.query_pod_fcl == null || state.userInfo.query_pod_fcl == '' ?  []:state.userInfo.query_pod_fcl.split("|")
		},
		
		
		//海运拼箱历史查询
		historyquery_lcl:(state)=>{
			return state.userInfo.historyquery_lcl == null || state.userInfo.historyquery_lcl == '' ?  []:state.userInfo.historyquery_lcl.split("|")
		},
		query_pod_lcl:(state)=>{
			return state.userInfo.query_pod_lcl == null || state.userInfo.query_pod_lcl == '' ?  []:state.userInfo.query_pod_lcl.split("|")
		},
		
		
		//空运历史查询
		historyquery_air:(state)=>{
			return state.userInfo.historyquery_air == null || state.userInfo.historyquery_air == '' ?  []:state.userInfo.historyquery_air.split("|")
		},
		query_pod_air:(state)=>{
			return state.userInfo.query_pod_air == null || state.userInfo.query_pod_air == '' ?  []:state.userInfo.query_pod_air.split("|")
		},
		
		//铁路历史查询
		historyquery_railroad:(state)=>{
			return state.userInfo.historyquery_railroad == null || state.userInfo.historyquery_railroad == '' ?  []:state.userInfo.historyquery_railroad.split("|")
		},
		query_pod_railroad:(state)=>{
			return state.userInfo.query_pod_railroad == null || state.userInfo.query_pod_railroad == '' ?  []:state.userInfo.query_pod_railroad.split("|")
		},
		//内陆拖车历史查询
		historyquery_trailer:(state)=>{
			return state.userInfo.historyquery_trailer == null || state.userInfo.historyquery_trailer == '' ?  []:state.userInfo.historyquery_trailer.split("|")
		},
		query_pod_trailer:(state)=>{
			return state.userInfo.query_pod_trailer == null || state.userInfo.query_pod_trailer == '' ?  []:state.userInfo.query_pod_trailer.split("|")
		},
		//国际快递历史查询
		historyquery_express:(state)=>{
			return state.userInfo.historyquery_express == null || state.userInfo.historyquery_express == '' ?  []:state.userInfo.historyquery_express.split("|")
		},
		query_pod_express:(state)=>{
			return state.userInfo.query_pod_express == null || state.userInfo.query_pod_express == '' ?  []:state.userInfo.query_pod_express.split("|")
		},
		
		//审核资料状态
		audit_zl:(state)=>{
			return state.userInfo.audit_zl
		},
	},

})
